import { useDispatch } from 'react-redux';

import { AppDispatch } from 'store';

type DispatchFunc = () => AppDispatch;

// eslint-disable-next-line import/prefer-default-export
export const useAppDispatch: DispatchFunc = useDispatch;
